<template>
    <div class="health_table">
        <p v-if="hasLine" class="homeComTitle hasLine">
            <span class="titleLine"></span>
            <span>{{ title }}</span>
        </p>
        <p v-else class="title">{{ title }}</p>

        <div v-if="!slotmag" class="mag">
            <p v-if="content">{{ content }}</p>
        </div>
        <slot v-else></slot>

        <table v-if="items.length">
            <thead class="thead">
            <tr>
                <td v-for="item in head" :key="item.name">{{ item.name }}</td>
            </tr>
            </thead>
            <tbody class="tbody fs14 font_n">
            <tr v-for="(item,index) in items" :key="index">
                <td v-for="(subItem, subIndex) in head" :key="subIndex">
                    <p v-if="subItem.name === '舆情健康指数'"
                       :class="{co_green: item[subItem.key] >=80, co_orange: item[subItem.key] >= 60 && item[subItem.key] < 80, co_red: item[subItem.key] < 60 }">
                        <span class="fs24 font_b">{{ item[subItem.key] }}</span>分
                    </p>
                    <span v-else>{{ subItem.key === 'indexNumber' ? (index + 1) : item[subItem.key] }}</span>

                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        renderData: Object,
        hasLine: Boolean,
        slotmag: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            head: [],
            items: [],
            content: "",
            title: ""
        }

    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.title = this.renderData?.title || "";
            this.content = this.renderData?.content || "";
            this.head = this.renderData?.head || [];
            this.items = this.renderData?.items || [];

        }
    },

}
</script>

<style lang="scss" scoped>
.health_table {
    font-family: PingFangSC-Regular;
    box-sizing: border-box;
    text-align: left;
    padding: 16px 16px 0px 16px;

    .title {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        text-indent: 20px;
        background-size: 18px 18px;
        background: url("../../assets/img/icon/media.png") no-repeat left;

    }

    .mag {
        font-size: 14px;
        color: #333333;
        margin-top: 12px;
    }

    table {
        font-size: 12px;
        color: #666666;
        width: 100%;
        margin-top: 28px;
        margin-bottom: 20px;

        tr {
            width: 100%;
            text-align: center;

            td {
                &:nth-of-type(1) {
                    width: 15%;
                }

                &:nth-of-type(2) {
                    width: 8%;
                    margin-left: 5%;
                }

                &:nth-of-type(3) {
                    width: 30%;
                    margin-left: 47%;
                }

            }
        }

        .thead {
            tr {
                color: #666666;
                display: flex;
                line-height: 20px;
            }
        }

        .tbody {
            font-size: 14px;
            color: #333333;

            tr {
                display: flex;

                td {
                    height: 36px;
                    line-height: 36px;
                    //overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    b {
                        width: auto;
                        height: 36px;
                        line-height: 36px;
                        vertical-align: middle;
                    }

                    &:nth-of-type(1) {
                        overflow: hidden;
                    }

                    &:nth-of-type(2) {
                        //overflow: hidden;
                        //vertical-align
                    }

                    &:nth-of-type(3) {
                        overflow: hidden;

                    }
                }
            }
        }

        .barBoxBg {
            background-color: #c3d2f0;
            overflow: hidden;
        }

        .barBox {
            width: 100%;
            height: 16px;
            border-radius: 8px;

            p {
                height: 100%;

                &:nth-child(1) {
                    background-color: #386ccf;
                }

                &:nth-child(2) {
                    background-color: #86a7e2;
                }
            }

            span {
                height: 100%;
            }
        }
    }

}
</style>